export default __webpack_public_path__ + "static/media/Imagen_descriptiva_atributo_potencia.feffdecf.jpg";